import { Avatar, Typography } from "@mui/material";
import { styled, useTheme } from "@mui/system";
import BasicMenu from "../BasicMenu";
import { BoxUpper } from "../BoxUpper";
import { BoxBodyContainer, PriceComponent, RawBox, StyledAvatar, TagSection } from "./styled";
import { formatIndex, formatPrice } from "../../../helpers/dataFormat";
import shortid from "shortid";
import { personTypeConstants } from "../../../constants/personTypeConstants";
import { useNavigate } from "react-router-dom";
import AvatarSvg from "assets/images/avatar.svg";

const StyledBoxBodyContainer = styled(BoxBodyContainer)(({ theme }) => ({
  padding: 0,
  overflow: "auto",
  height: "350px",
}));
export const TotalDeptContainer = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.disabled.light,
  padding: "15px 24px",
}));

const DashboardPeopleList = ({
  title,
  count,
  totalPrice,
  arrayData,
}: {
  title?: string;
  count: number;
  totalPrice: number;
  arrayData: any[];
}) => {
  const theme = useTheme();
  return arrayData ? (
    <RawBox>
      <BoxUpper title={`${title} (${count})`} />
      <StyledBoxBodyContainer>
        <TotalDeptContainer>
          <PriceComponent  price={`${formatPrice(totalPrice)}`} color={'#000000'} />
        </TotalDeptContainer>
        {arrayData.map((item, key) => (
          <ListItem itemKey={key} item={item} key={shortid.generate()} />
        ))}
      </StyledBoxBodyContainer>
    </RawBox>
  ) : (
    <div>loading</div>
  );
};

const DebitCardContainer = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "16% 80%",
  gridGap: "10px",
  justifyContent: "space-between",
  height: "90px",
  padding: "15px 24px",
  border: `2px solid ${theme.palette.disabled.light}`,
}));
const DebitCardItem = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
}));
const PriceItem = styled(DebitCardItem)(({ theme }) => ({
  width: "auto",
  display: "flex",
  justifyContent: "end",
  alignItems: "center",
}));
const CustomerItem = styled(DebitCardItem)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-evenly",
}));
const CustomerInfoContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
}));

const ListItem = ({ item, itemKey }: { item: any; itemKey: number }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <DebitCardContainer>
      <DebitCardItem>
        <StyledAvatar src={item.avatar || AvatarSvg} />
      </DebitCardItem>
      <CustomerItem>
        <a
          style={{ cursor: "pointer", color: "rgb(0,0,0)", fontSize: 14 }}
          className="hover:text-blue-1"
          target="_blank"
          href={`/reports/personalAccountCard?personId=${item.id}`}
        >{`${formatIndex(itemKey, 3)} - ${item?.nickName}`}</a>
        <CustomerInfoContainer>
          <TagSection variant="caption" color={theme.palette.primary.main} textAlign="center">
            {/* @ts-ignore */}
            {personTypeConstants[item.personType] || ""}
          </TagSection>
          <PriceItem>
            <PriceComponent price={`${formatPrice(item.balance)}`} color={theme.palette.text.main} />
          </PriceItem>
        </CustomerInfoContainer>
      </CustomerItem>
    </DebitCardContainer>
  );
};

export default DashboardPeopleList;
